var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuoteRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7267 10.2733C15.1409 8.73847 14.9985 6.76744 14.994 6.74496V4.49664V0.74944C14.994 0.335749 14.659 0 14.2446 0H9.74797C8.92133 0 8.24909 0.672248 8.24909 1.49888V6.74496C8.24909 7.15865 8.58409 7.4944 8.99853 7.4944H9.74797H11.3053C11.2896 7.79568 11.2131 8.17789 10.9838 8.54062C10.6031 9.14092 9.88586 9.55086 8.85089 9.75771L8.24909 9.87762V11.991H8.99853C11.0842 11.991 12.6753 11.4132 13.7267 10.2733ZM5.47766 10.2733C6.8926 8.73847 6.74946 6.76744 6.74496 6.74496V4.49664V0.74944C6.74496 0.335749 6.40996 0 5.99552 0H1.49888C0.672248 0 0 0.672248 0 1.49888V6.74496C0 7.15865 0.335 7.4944 0.74944 7.4944H1.49888H3.05622C3.04048 7.79568 2.96404 8.17789 2.73471 8.54062C2.35399 9.14092 1.63678 9.55086 0.6018 9.75771L0 9.87762V11.991H0.74944C2.83513 11.991 4.42619 11.4132 5.47766 10.2733Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteRight);
export default __webpack_public_path__ + "static/media/quoteRight.cd3fdc0d404f05951baf5320b01bf0ca.svg";
export { ForwardRef as ReactComponent };